import React from 'react';
import Button from 'common/components/Button';
import Icon from 'common/components/Icon';

import styles from './index.module.css';

const NewOffRampButton = ({ navigateToNewOffRamp }) => (
  <div className={styles.newOffRampButton}>
    <Button
      full
      icon={<Icon.Plus description="Dollar circle" size="medium" />}
      kind="primary"
      onClick={navigateToNewOffRamp}
    >
      <button type="button">New off ramp</button>
    </Button>
  </div>
);

export default NewOffRampButton;
